import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { tokenStore } from "@/lib/api";
import { trySilentSso } from "@/lib/silentSso";
import { planGate } from "@/lib/planGate";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

trySilentSso({ hasToken: () => !!tokenStore.get(), setToken: (t) => tokenStore.set(t) });

// A free account that opens a paid app's address directly gets an upgrade notice, not the app.
planGate({ product: "poems", getToken: () => tokenStore.get() }).then((ok) => {
  if (!ok) return;
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
});

// Registered unconditionally, including in dev — Chrome's installability
// check (and therefore the beforeinstallprompt event the install button
// depends on) requires an active service worker. Gating this to production
// builds meant beforeinstallprompt could never fire while testing locally,
// so the install button always fell back to manual instructions.
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch(() => { /* ignore */ });
    });
}
